import React from "react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { formatCurrency } from "@/lib/format";
import { ArrowRight } from "lucide-react";

interface CartFooterProps {
  subtotal: number;
  onCheckout: () => void;
  onClose: () => void;
}

export const CartFooter: React.FC<CartFooterProps> = ({
  subtotal,
  onCheckout,
  onClose,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">Subtotal</span>
        <span>{formatCurrency(subtotal / 100)}</span>
      </div>
      
      <div className="flex justify-between font-medium text-lg">
        <span>Total</span>
        <span>{formatCurrency(subtotal / 100)}</span>
      </div>
      
      <Button 
        className="w-full h-12 group bg-red-600 hover:bg-red-700 text-white shadow-lg font-bold text-lg border-4 border-yellow-400"
        onClick={() => {
          console.log('CartFooter - Checkout button clicked!');
          onCheckout();
        }}
      >
        <span>🛒 CHECKOUT NOW 💳</span>
        <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
      </Button>
      
      <Button 
        variant="outline" 
        className="w-full border-muted/50 shadow-sm"
        onClick={onClose}
      >
        Continue Shopping
      </Button>
    </div>
  );
};
